<template functional>
  <SocialImage
    title="Bluesky"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    channel="bluesky"
    v-on="listeners"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'BlueskyImage',
  components: {
    SocialImage,
  },
};
</script>

